import React from "react";
// import CategoryWhyChooseUs from "../category-components/CategoryWhyChooseUs";
import IndianStreetFeatureSection from "../category-components/IndianStreetFeatureSection";
import IndianStreetProduct from "../category-components/IndianStreetProduct";
import BreadcrumbBanner from "../components/BreadcrumbBanner";
import SeoHelmet from "../Seo/SeoHelmet";
import IndianStreetChoose from "../category-components/IndianStreetChoose";
const IndianStreetFood = () => {
  return (
    <div>
      <SeoHelmet page="indian-street-food" />
      <BreadcrumbBanner
        title="Indian Street Food"
        backgroundImage="/Images/banner-about.jpg"
      />
      <IndianStreetFeatureSection />
      <IndianStreetProduct />
     <IndianStreetChoose/>
    </div>
  );
};

export default IndianStreetFood;
